import React from 'react';
import PropTypes from 'prop-types';

import LineTitleGray from '../atoms/titles/LineTitleGray';

const PlanContent = (props) => {
  const { title, children } = props;
  return (
    <div className="PlanContentContainer">
      <LineTitleGray>
        {title}
      </LineTitleGray>
      <div className="PlanContentBody">
        {children}
      </div>
    </div>
  );

};

PlanContent.defaultProps = {
};

PlanContent.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
};

export default PlanContent;